import React from "react";
import { useNavigate } from "react-router-dom";
import WaitingRoom from "../../../WaitingRoom/pages/WaitingRoom/WaitingRoom";
import AppLayoutAssistant from "../../../navigation/Layout/LayoutAssistant";
import { ASSISTANT_ROUTES } from "../../../routes/patientRoutes/routePaths";
import useAssistantDoctorId from "../../hooks/useAssistantDoctorId";

export default function AssistantWaitingRoomPage() {
  const doctorId = useAssistantDoctorId();
  const navigate = useNavigate();

  const openPaymentHistory = (patient) => {
    const patientId = patient.patientId || patient.userId || patient.principalUserId || patient.id;
    if (!patientId) return;
    const query = new URLSearchParams();
    if (patient.subprofileId) query.set("subprofileId", patient.subprofileId);
    const route = ASSISTANT_ROUTES.PAYMENT_HISTORY(patientId);
    navigate(`${route}${query.toString() ? `?${query}` : ""}`, {
      state: {
        returnTo: ASSISTANT_ROUTES.WAITING_ROOM,
        patient: {
          id: patientId,
          name: patient.name,
          fullName: patient.fullName,
          firstName: patient.firstName,
          lastName: patient.lastName,
          phone: patient.phone || patient.phoneNumber,
          email: patient.email,
        },
      },
    });
  };

  return (
    <WaitingRoom
      LayoutComponent={AppLayoutAssistant}
      disableRemote={!doctorId}
      localPatients={[]}
      showOpenFile={false}
      doctorIdOverride={doctorId}
      onOpenPaymentHistory={openPaymentHistory}
    />
  );
}
